<template>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirRotinas" centered>
        <template #modal-header>
            <div class="col-10">
                <h4>Configuração de agendamento!</h4>
            </div>
        </template>

        <div class="col-12">
            <div class=" mt-3 ">
                <h6>Selecione uma empresa:</h6>
                <v-select :options="getEmpresas" v-model="selectEmpresa">
                </v-select>
            </div>
            <div class=" mt-3 ">
                <h6>Selecione uma rotina:</h6>
                <v-select :options="rotinas" v-model="selectRotina">
                </v-select>
            </div>
            <div class="row">
                <div class="col-6 mt-3">
                    <h6>Dia:</h6>
                    <v-select :options="dias" v-model="selectDia">
                    </v-select>
                </div>
                <div class="col-6 mt-3 ">
                    <h6>Hora:</h6>
                    <v-select :options="horas" v-model="selectHora">
                    </v-select>
                </div>
            </div>
            <div class=" mt-3 d-none">
                <h6>E-mails:</h6>
                <input class="form-control" v-model="emails">
            </div>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center; ">
                    <div class="row center" style="justify-content: center; ">
                        <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                            Fechar
                        </b-button>
                        <b-button size="lg" variant="success" @click="salvarAgendamento">
                            Salvar
                        </b-button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            exibirRotinas: true,
            selectEmpresa: {},
            selectRotina: {},
            selectDia: {},
            selectHora: {},
            acaoGlobal: '',
            nr_sequencial: '',
            nr_seq_agendamento: '',
            emails: ''
        }
    },

    props: {
        agendamento: {}
    },

    computed: {
        getEmpresas() {
            const empresas = this.$store.getters['painel/getEmpresas']

            if (!empresas) {
                this.$store.dispatch('painel/getEmpresas')

                return []
            }

            return empresas.map(empresa => {
                return {
                    ...empresa,
                    label: empresa.name.toUpperCase()
                }
            })
        },

        rotinas() {
            const rotinas = this.$store.getters['painel/getRotinas']

            if (!rotinas) {
                this.$store.dispatch('painel/getRotinas')

                return []
            }

            return rotinas.map(rotina => {
                return {
                    ...rotina,
                    label: rotina.nome_rotina.toUpperCase()
                }
            })
        },

        dias() {
            const dias = this.$store.getters['painel/getDias']

            return dias.map(dia => {
                return {
                    ...dia,
                    label: dia.dia_semana
                }
            })
        },

        horas() {
            const arrHoras = ['HORA EM HORA']

            for (let i = 0; i <= 23; i++) {
                arrHoras.push(`${i}`)
            }

            return arrHoras.map(hora => {
                return {
                    ...hora,
                    label: hora
                }
            })
        },

        empresa() {
            return this.$store.getters['painel/getEmpresa']
        }
    },

    methods: {
        salvarAgendamento() {
            const data = {
                rotina: this.selectRotina.nr_sequencial,
                dia: this.selectDia.label,
                hora: this.selectHora.label,
                nr_seq_empresa: this.selectEmpresa.id,
                acao_global: this.acaoGlobal,
                emails: this.emails,
                nr_seq_arquivo: this.nr_seq_agendamento,
                nr_seq_agendamento_cliente: this.agendamento.nr_seq_agendamento_cliente
            }

            this.$store.dispatch('painel/acaoAgendamento', { data: data }).then(response => {
                this.$emit('closeModal')
                this.$store.dispatch('painel/getAgendamentos', { data: this.empresa.name })
                this.$swal.fire({
                    title: 'Sucesso!',
                    text: 'Agendamento salvo com sucesso!',
                    icon: 'success',
                    timer: 1000
                })
            })
        },

    },

    created() {
        this.$store.dispatch('painel/getRotinas')
        this.$store.dispatch('painel/getEmpresas')

        if (this.agendamento == '') {
            this.acaoGlobal = 'salvar'
            this.selectEmpresa.label = this.empresa.name
            this.selectEmpresa.id = this.empresa.id
        } else {
            this.nr_sequencial = this.agendamento.nr_sequencial
            this.selectRotina.label = this.agendamento.nome_rotina
            this.selectRotina.nr_sequencial = this.agendamento.nr_seq_arquivo
            this.selectDia.label = this.agendamento.dia_semana
            this.selectHora.label = this.agendamento.hora
            this.emails = this.agendamento.ds_email

            this.nr_seq_agendamento = this.agendamento.nr_seq_agendamento
            this.acaoGlobal = 'editar'
        }
    }
}
</script>